import React, { FunctionComponent } from "react";
import { useTheme, Theme, Container } from "@material-ui/core";
import BackgroundImage from "gatsby-background-image";
import { BlogContentBox, TextOverlayType } from "./styledComponents";
import { getBackgroundImageStack, HeroImage } from "./hero";

interface BlogHeroProps {
    image: import("gatsby-source-filesystem").FileSystemNode;
    title: string,
    overlayColor?: string,
}

const BlogHero : FunctionComponent<BlogHeroProps> = (props) => {
    const theme = useTheme<Theme>();
    let color = props.overlayColor;
    if(!color) {
        color = theme.palette.primary.dark;
    }
    return (
        <>
        <HeroImage fluid={getBackgroundImageStack((props.image.childImageSharp as any).fluid, color)} Tag="section">
            <Container maxWidth="md">
                <BlogContentBox theme={theme} display="flex" alignItems="center" height="65vh" minHeight={450} py={8}>
                    <TextOverlayType shadowColor={color} variant="h1" align="left">{props.title}</TextOverlayType>
                </BlogContentBox>
            </Container>
        </HeroImage>
        </>
    );
}

export default BlogHero;